module.exports = __webpack_public_path__ + "static/img/index3(1)_03.065b478.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/images/index3(1)_03.png
// module id = 3125
// module chunks = 1